import React, { useEffect, useState } from "react";
import styles from "./AboutUs.module.css";
import { Link } from "react-router-dom";
import AboutDescription from "./AboutDescription";
import { useLocation } from "react-router-dom";
import HeaderWithLeaf from "../../HeaderWithLeaf";
import PageTitleWithLeaf from "../../PageTitleWithLeaf";
import { removeFont16pxFromStyle } from "../../../utils/utils.function";

function AboutUsPage({ initialValues }) {
  
  const [showContent, setShowContent] = useState(false);
  const [clickedIndex, setClickedIndex] = useState(-1);
  const [expandedContent, setExpandedContent] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/certification") {
      setShowPdf(true);
    } else {
      setShowPdf(false);
    }
  }, [location.pathname]);
  const [showPDF, setShowPdf] = useState(false);

  const showContentHandler = (e, index) => {
    e.preventDefault();

    // If the content is already expanded, reset to original position
    if (index === clickedIndex && showContent) {
      setClickedIndex(-1);
      setShowContent(false);
    } else {
      setClickedIndex(index);
      setShowContent(true);
    }
  };

  const getEndValue = () => {
    if (window) {
      if (window.innerWidth <= 1366) {
        return 70;
      } else if (window.innerWidth <= 1366) {
        return 90;
      } else if (window.innerWidth <= 1440) {
        return 90;
      } else if (window.innerWidth <= 1920) {
        return 150;
      }
    }
  };

  return (
    <>
      <div className={styles.aboutUs}>
        {initialValues && initialValues?.firstSection?.[0]?.heading && (
          <div className="section-spacing-top">
            <PageTitleWithLeaf
              text={initialValues?.firstSection?.[0]?.heading}
            />
          </div>
        )}
        <div className={`${styles.aboutUs} section-spacing-bottom`}>
          <div className={` container ${styles.firstSection}`}>
            <div className={styles.column1}>
              {initialValues !== undefined &&
                initialValues?.firstSection?.map((value, index) => {
                  return (
                    <div
                      className={`${styles.aboutUpper} ${
                        index === initialValues?.firstSection.length - 1
                          ? "section-spacing-bottom"
                          : ""
                      }`}
                      key={index}
                    >
                      {/* <div className={styles.aboutUpper} key={index}> */}
                      <div
                        className={`${styles.aboutSection} ${
                          value?.mainImage
                            ? styles.aboutSection65
                            : styles.aboutSection100
                        }  ${styles.secondDesc}
                        ${index == 0 ? styles.zeroIndexHading : ""}

                        `}
                      >
                        <div className={styles.headingDiv}>
                          {/* <h2>
                          {index != 0 && value?.heading}
                          {index != 0 &&
                            <img
                              src="./assets/images/home/leaf-1-1 1.webp"
                              alt="Leaf"
                              loading="lazy"
                              className={styles.leaf1}

                            />
                          }
                        </h2> */}
                          {index != 0 && (
                            <HeaderWithLeaf text={value?.heading} />
                          )}
                        </div>
                        <div
                          // className={'${index != 0 ? agricultureCard : agricultureCardFirstHeading}  '}
                          className={` ${
                            index !== 0
                              ? "agricultureCard"
                              : "agricultureCardFirstHeading"
                          }`}
                          // style={{ textAlign: "left !Important", marginTop: '36px !important' }}
                          dangerouslySetInnerHTML={{ __html: removeFont16pxFromStyle(value?.content) }}
                        />
                      </div>

                      {value?.mainImage ? (
                        <div className={styles.imgSection}>
                          <img
                            src={value?.mainImage}
                            alt={value?.mainImageAlt}
                            className={
                              index == 0
                                ? styles.mainImageZeroIndexSection
                                : styles.mainImageSection
                            }
                          />
                        </div>
                      ) : null}
                    </div>
                  );
                })}
            </div>
          </div>
          {showPDF ? (
            <div style={{ height: "80vh" }}>
              <embed
                src="/BUREAU_VERITAS_ORGANIC_CERTY.pdf#toolbar=0&navpanes=0&scrollbar=0"
                type="application/pdf"
                width="100%"
                height="100%"
              />
            </div>
          ) : (
            <>
              {initialValues?.thirdSection[0].heading?.length > 0 && (
                <>
                  <AboutDescription
                    value={
                      initialValues !== undefined && initialValues?.thirdSection
                    }
                  />
                </>
              )}
            </>
          )}
          {initialValues?.secondSection[0].heading?.length > 0 && (
            <div className="container">
              <div className={`${styles.secondHeading}`}>
                {/* <h2> */}
                {/* {initialValues?.secondSectionHeading} */}
                {initialValues?.secondSectionHeading && (
                  <HeaderWithLeaf text={initialValues?.secondSectionHeading} />
                )}
                {/* <img
                  src="./assets/images/home/leaf-1-1 1.webp"
                  alt="Leaf"
                  loading="lazy"
                  className={styles.leaf4}
                /> */}
                {/* </h2> */}
              </div>
              <div className={`${styles.secondSection}`}>
                {initialValues?.secondSection !== "" &&
                  initialValues?.secondSection?.map((value, index) => (
                    <div className={styles.column1} key={index}>
                      <div className={styles.aboutCardContainer}>
                        <img
                          className={styles.cardImage}
                          src={value?.image}
                          alt={value?.imageAlt}
                          loading="lazy"
                        />
                        <div className={styles.aboutCard}>
                          {value.content !== "" && (
                            <>
                              <h3 className={styles.secondSectionHeading}>
                                {value?.heading}
                              </h3>
                              {index === clickedIndex ? (
                                <p className={`${styles.paragraphContent}`}>
                                  {value.content}
                                </p>
                              ) : (
                                <>
                                  <p className={`${styles.paragraphContent}`}>
                                    {value?.content
                                      .split("")
                                      .slice(0, getEndValue())
                                      .join("")}
                                    ...
                                  </p>
                                </>
                              )}
                            </>
                          )}
                        </div>{" "}
                        {value.content !== "" && (
                          <button onClick={(e) => showContentHandler(e, index)}>
                            {index === clickedIndex && showContent
                              ? "Read Less"
                              : "Read More"}
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default React.memo(AboutUsPage);
